import { getAssetURL } from "helpers/assets";

const TARALITE_LOGO_GCS_PATH = "taralite-com/assets/images/logos";

const omuLogo = getAssetURL(`${TARALITE_LOGO_GCS_PATH}/omu-black.svg`);
const omuWhiteLogo = getAssetURL(`${TARALITE_LOGO_GCS_PATH}/omu-white.svg`);
const taraliteGreenLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovofinansial-purple.svg`
);
const taraliteWhiteLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovofinansial-white.svg`
);
const ojkLogo = getAssetURL(`${TARALITE_LOGO_GCS_PATH}/ojk.png`);
const afpiLogo = getAssetURL(`${TARALITE_LOGO_GCS_PATH}/afpi.png`);
const ovoPaylaterLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovoPaylaterLogo.svg`
);
const purpleOVOPaylaterLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/purpleovoPaylaterLogo.svg`
);

const grabModalMantulLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/grabModalMantulLogo.svg`
);
const grabModalMantulBigLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/grabModalMantulBigLogo.svg`
);
const ovoModalUsahaLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovoModalUsahaLogo.svg`
);
const purpleOVOModalUsahaLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/purpleOVOModalUsahaLogo.svg`
);

const ovoModalUsahaMitraLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovoModalUsahaMitraLogo.svg`
);
const ovoModalUsahaMitraPeminjanLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovoModalUsahaMitraPeminjanLogo.svg`
);
const ovoModalUsahaMitraPurpleLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovo-modal-usaha-mitra-purple.svg`
);

const ovoModalUsahaPeminjamPurpleLogo = getAssetURL(
  `${TARALITE_LOGO_GCS_PATH}/ovo-modal-usaha-peminjam-purple.svg`
);

export {
  omuLogo,
  omuWhiteLogo,
  taraliteGreenLogo,
  taraliteWhiteLogo,
  ojkLogo,
  afpiLogo,
  ovoPaylaterLogo,
  purpleOVOPaylaterLogo,
  purpleOVOModalUsahaLogo,
  grabModalMantulLogo,
  ovoModalUsahaLogo,
  ovoModalUsahaMitraLogo,
  ovoModalUsahaMitraPeminjanLogo,
  grabModalMantulBigLogo,
  ovoModalUsahaMitraPurpleLogo,
  ovoModalUsahaPeminjamPurpleLogo,
};
